var _templateObject = _taggedTemplateLiteralLoose(['\n  min-height: ', ';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n  height: 100%;\n  width: 100%;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  border: ', ';\n'], ['\n  min-height: ', ';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n  height: 100%;\n  width: 100%;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  border: ', ';\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
var Container = styled.div(_templateObject, function (props) {
  return props.minheight || '0';
}, function (props) {
  return props.debug ? '1px solid red' : 'none';
});

var Centered = function Centered(props) {
  return React.createElement(Container, props, props.children);
};

export default Centered;